import { convertLexicalToHTML } from '@payloadcms/richtext-lexical/html'
import { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical'

export function removeInvalidLiValueAttributes(html: string): string {
  const stripLiValue = (inner: string) =>
    inner.replace(/<li(\s[\s\S]*?)>/gi, (_, attrs) => {
      const cleaned = attrs
        .replace(/\s+value="[^"]*"/gi, '')
        .replace(/^value="[^"]*"\s*/i, '')
      return `<li${cleaned}>`
    })

  let result = html
  let prev: string
  do {
    prev = result
    result = result.replace(
      /<ul([^>]*)>([\s\S]*?)<\/ul>/gi,
      (_, attrs, inner) => `<ul${attrs}>${stripLiValue(inner)}</ul>`
    )
  } while (result !== prev)

  return result
}

function silentConvertLexicalToHTML(data: SerializedEditorState): string {
  const originalError = console.error
 
  console.error = (...args: any[]) => {
    const message = String(args[0] || '')
    if (message.includes('internalDocToHref') || 
        message.includes('Link converter') ||
        message.includes('Lexical =>')) {
      return // Não exibir
    }
    originalError.apply(console, args)
  }
  
  try {
    const result = convertLexicalToHTML({ data, disableContainer: true })
    return removeInvalidLiValueAttributes(result)
  } finally {
    console.error = originalError
  }
}

export function convertLexicalWithInternalLinks(data: SerializedEditorState) {
  try {
    let html = silentConvertLexicalToHTML(data)
    
    const linksData = findAllLinksInData(data)
    
    linksData.forEach((linkData) => {
      const correctUrl = formatLinkData(linkData)
      
      if (correctUrl !== '#') {
        html = html.replace('href="#"', `href="${correctUrl}"`)
      }
    })

    return html
    
  } catch (error) {
    console.error("Erro:", error)
    return silentConvertLexicalToHTML(data)
  }
}

function findAllLinksInData(data: any): any[] {
  const links: any[] = []
  
  function traverse(obj: any) {
    if (typeof obj !== 'object' || obj === null) return
    
    if (obj.type === 'link') {
      links.push(obj)
    }
    
    if (obj.linkType !== undefined || obj.doc || obj.url) {
      links.push(obj)
    }
    
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (Array.isArray(obj[key])) {
          obj[key].forEach(traverse)
        } else if (typeof obj[key] === 'object') {
          traverse(obj[key])
        }
      }
    }
  }
  
  traverse(data)
  return links
}

function formatLinkData(linkData: any): string {
  const structures = [
    linkData.fields?.doc?.value?.slug,
    linkData.doc?.value?.slug,
    linkData.fields?.doc?.slug,
    linkData.doc?.slug,
    linkData.value?.slug,
    linkData.slug
  ]
  
  for (const slug of structures) {
    if (slug && typeof slug === 'string') {
      return `/${slug}`
    }
  }
  
  if (linkData.fields?.url || linkData.url) {
    return linkData.fields?.url || linkData.url
  }
  
  return '#'
}